import React from 'react';
import { MenuItem } from '@mui/material';
import type { RowState } from '@internal/backstage-plugin-bidone-backend';
import { StateSelectField } from './styles';

export const STATE_LABEL: Record<RowState, string> = {
  not_ready: 'Not ready',
  no_changes: 'No changes',
  tagged: 'Tagged',
};

// Interactive state dropdown. Fires immediately on change — there's no
// section lock involved (per spec: state is mutated outside the global
// Edit mode). The trigger inherits the same colour as the corresponding
// row tint so the live state is visible in one glance.
//
// Uses TextField+select rather than bare Select because the compact
// variant only kicks in via TextField's `size="small"` prop; a raw
// `<Select size="small">` is silently ignored, producing a much taller
// trigger than the rest of the table chrome. StateSelectField wraps
// TextField with the row-state-driven tint.
export const StateSelect: React.FC<{
  state: RowState;
  onChange: (next: RowState) => void;
  // Disabled while the parent section is in Edit mode (per spec: state
  // cannot be edited within the section's global Edit lock).
  disabled?: boolean;
}> = ({ state, onChange, disabled }) => {
  return (
    <StateSelectField
      select
      size="small"
      value={state}
      onChange={e => onChange(e.target.value as RowState)}
      variant="outlined"
      fullWidth
      disabled={disabled}
      rowState={state}
      // Stop the click from triggering any cell-level handlers / row
      // selection — the dropdown is its own affordance.
      onClick={e => e.stopPropagation()}
    >
      {(Object.keys(STATE_LABEL) as RowState[]).map(s => (
        <MenuItem key={s} value={s}>
          {STATE_LABEL[s]}
        </MenuItem>
      ))}
    </StateSelectField>
  );
};
